import mapValues from "lodash/mapValues"
import * as modules from "./modules"

const keyedModules = mapValues(modules, (v, key) => ({
  key,
  ...v,
}))

export const artLecturer = [
  keyedModules.activity,
  keyedModules.illustrtion,
  keyedModules.promotion,
]

export const creator = [
  keyedModules.promotion,
  keyedModules.marketing,
  keyedModules.developing,
  keyedModules.activity,
]

export const lecturer = [
  keyedModules.activity,
  keyedModules.professional,
  keyedModules.promotion,
]

export const allModules = Object.values(keyedModules)

const templates = [
  { value: 'creator', label: '圖文創作者', template: creator },
  { value: 'artLecturer', label: '藝術設計講師', template: artLecturer },
  { value: 'lecturer', label: '專業講師', template: lecturer },
]

export default templates
